var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28 6.046c.74 0 1.532-.683 1.532-1.774 0-1.09-.792-1.774-1.531-1.774-.739 0-1.531.683-1.531 1.774s.792 1.774 1.53 1.774zm0 1.5c1.675 0 3.032-1.466 3.032-3.274S5.955.998 4.28.998C2.607.998 1.25 2.464 1.25 4.272s1.357 3.274 3.03 3.274zm10.18-6.319a.75.75 0 01.041 1.06L2.956 14.76a.75.75 0 11-1.1-1.019L13.4 1.268a.75.75 0 011.06-.04zm-.71 10.062c0 1.09-.792 1.774-1.53 1.774-.74 0-1.532-.684-1.532-1.774 0-1.091.792-1.775 1.531-1.775.739 0 1.531.684 1.531 1.775zm1.5 0c0 1.808-1.357 3.274-3.03 3.274-1.675 0-3.032-1.466-3.032-3.274 0-1.809 1.357-3.275 3.031-3.275 1.674 0 3.031 1.466 3.031 3.275z",
    fill: "currentColor"
  })));
}
export default SvgStake;